import { Component, OnInit } from '@angular/core';
import { GAccsessService } from 'src/app/services/g-accsess.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MainComponent } from '../main/main.component';

@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.css']
})
export class AddCategoryComponent implements OnInit {

  typearr:any
  typeId:any
  typename:any = "Choose Type"
  categroyName:any = ""
  submitted = false
  constructor(private rest : GAccsessService, public dialogRef: MatDialogRef<MainComponent>,){}

  ngOnInit(){
    this.getTypes()
  }

  getTypes(){
    this.rest.getTypes().subscribe((res:any) => {
      console.log(res)
      this.typearr = res.children
    })
  }

  gettypeInfo(item:any){
    this.typename = item.name
    this.typeId = item.id
  }

  submit(){
    this.submitted = true
    if(this.categroyName != ""){
      if(this.typename == 'Choose Type'){
        let data = {
          name : this.categroyName,
          parent_id : 1
        }
        this.dialogRef.close(data);

      }else {
        let data = {
          name : this.categroyName,
          parent_id : this.typeId
        }
        this.dialogRef.close(data);
      }
     
    }
  }
}
